import _ from 'lodash';
import qs from 'qs';

import F from '../../commons/HTTPFetcher';
import * as ContentTypes from '../../commons/constants/HTTPContentTypes';

export const getReturningCustomersAgg = ({ restriction, filters, aggregation }) => {
  return F.post('/returning-customer/aggregate', {
    body: {
      restriction,
      filters,
      aggregation
    },
    contentType: ContentTypes.JSON
  });
};

export const getReturningCustomersSearch = ({ filters, sort, max }) => {
  const url = '/returning-customer/search';
  const urlSearch = qs.stringify({ max }, { addQueryPrefix: true });

  return F.post(`${url}${urlSearch}`, {
    body: {
      filters,
      sort
    },
    contentType: ContentTypes.JSON
  });
};
